
define( 'system/js/app',[ 'jclass', 'jquery', 'system/js/stacktrace.min', 'font', 'timer', 'system/js/cache', 'system/js/conduit', 'system/js/model', 'system/js/view', 'system/js/tutorial', 'system/js/emitter', 'logger', 'editor/js/user_monitoring', 'plugins', 'system/js/jquery.browser.min', 'system/js/jquery.validate.min', 'inview', 'velocity', 'velocity_ui', 'velocity_easeplus', 'bootstrap', 'system/js/bootstrap.notify.min', 'datetimepicker' ], function( Class, $, StackTrace, Font, Timer, Cache, Conduit, Model, View, Tutorial, Emitter, Logger, UserMonitoring ) {
	'use strict';

	/*
	===============================================================================
	Class: App
	===============================================================================
	*/

	var App = Class._extend( {

		/**
		 * Method: init
		 */

		init: function( aOptions ) {
			var options = aOptions || { },
				link, i, len,
				self = this;

			this._version = false;
			this._verbose = false;
			this._csrf = false;
			this._iframe = false;
			this._errors = [ ];
			this._display_errors = false;

			this._module = null;
			this._unload = null;

			// AB tests are owned by the app for convenience.
			// AB information passed inside module data is appended appropriately to this._ab.
			this._ab = [ ];

			this._loaded = -1;
			this._unloading = false;

			// Promise array that will be executed before window execute `popstate`
			this.beforePopstatePromises = [ ];

			this._tutorial = null;
			this._FE = { };

			// internal post data attributes
			this._post = [ 'container', 'target', 'method', 'scope', 'success', 'error', 'modal', 'infinite', 'history', 'modified', 'per-page', 'ab' ];

			this._timer = new Timer( {
				parent: this,
				think: function( ) {
					if ( window.getComputedStyle( self._loading ).backgroundColor === 'rgb(0, 0, 0)' ) {
						self._loaded += 1;
					}

					return ( self._loaded < 0 );
				}
			} );

			this._idle = {
				fingerprint: 'pyUser-' + performance.now( ),
				timer: null,
				max: 239,
				interval: 60000,
				think: function( ) {
					var url = window.location.pathname,
						i = parseInt( self.getCache( 'idle' ), 10 ),
						a;

					if ( url !== '/login' && self.getCache( 'fingerprint' ) === self._idle.fingerprint ) {
						i += 1;

						self.setCache( 'idle', i );
					}

					if ( ( i > self._idle.max ) || ( i === -1 && url !== '/login' ) ) {
						self.setCache( 'idle', -1 );

						a = document.createElement( 'a' );
						a.setAttribute( 'href', '/logout' );

						self.handleLinkClick( a );
					}
				}
			};

			this._debounce = {
				timer: null,
				interval: 1000
			};

			this._cache = new Cache( {
				parent: this,
				engine: localStorage
			} );

			this._model = new Model( {
				parent: this
			} );

			this._strings = new Model( {
				parent: this
			} );

			this._view = new View( {
				parent: this
			} );

			this._history = {
				guid: null,
				direction: 0,
				action: false,
				restore: false,
				loader: null
			};

			this._conduit = [ ];

			this._emitter = new Emitter( { parent: this, enabled: options.emitter.enabled } );

			this._container = document.getElementById( 'pyDocument' );
			this.$container = $( this._container );

			this._modal = document.getElementById( 'pyModal' );
			this.$modal = $( this._modal );

			this._templates = document.getElementById( 'pyTemplates' );
			this.$templates = $( this._templates );

			this._tests = document.getElementById( 'pyTests' );
			this.$tests = $( this._tests );

			this.$overlay = this.$templates.find( '> div.overlay' );
			this._overlay = this.$overlay[ 0 ];

			this.$loading = this.$templates.find( '> div.loading' );
			this._loading = this.$loading[ 0 ];

			this._loader = {
				promises: [ ],
				animation_duration: 250,
				display_loader_duration: 500,
				_containers: {
					default: $( '#pyPageLoader' ),
					didYouKnow: $( '#pyDidYouKnowPageLoader' )
				}
			};

			this.setData( 'system.options', options );
			this.setData( 'system.views', [ ] );

			this.setCache( 'fingerprint', this._idle.fingerprint );
			this.setCache( 'idle', 0 );

			if ( Object.keys( options ).length > 0 ) {
				if ( options.hasOwnProperty( 'verbose' ) === true && options.verbose === true ) {
					this._verbose = true;

					this._view.verbose( );
				}

				if ( options.hasOwnProperty( 'enable_cache' ) === true && options.enable_cache === false ) {
					this._view.ajaxPartials( );
				}

				if ( options.hasOwnProperty( 'fonts' ) === true && $.isArray( options.fonts ) === true ) {
					for ( i = 0, len = options.fonts.length; i < len; i++ ) {
						link = 'font!' + options.fonts[ i ];

						this.verbose( 'app: load ' + link.replace( 'font!', '' ) );

						require( [ link ] );
					}
				}

				if ( options.hasOwnProperty( 'iframe' ) === true && options.iframe !== false ) {
					this._iframe = options.iframe;
				}
			}

			this.bindEventListeners( );

			this.setupFormValidator( );

			this._datadog = undefined;
			this._user_monitoring = new UserMonitoring( );
		},

		/**
		 * Method: bindEventListeners
		 */

		bindEventListeners: function( ) {
			var win = $( window ),
				doc = $( document ),
				self = this;

			$( 'html' ).addClass( 'cinder' );

			win.on( 'beforeunload.cinder', function( ) {
				if ( self.isUnloading( ) === true ) {
					self._unloading = true;
				}
			} );

			win.on( 'unload.cinder', function( ) {
				window.scrollTo( 0, 0 );
			} );

			win.on( 'popstate.cinder', function( aEvent ) {
				var data, a, p;

				if ( self._module !== null ) {
					self._module.beforePopstate( aEvent );
				}

				// execute beforePopstate promises before executing popstate.cinder
				// this is to make sure that the requested beforestate logics/tasks
				// is done first before popstate.cinder do its task/logic
				$.when.apply( $, self.beforePopstatePromises ).done( function( ) {
					if ( self._history.action === true ) {
						self._history.action = false;
					}
					else if ( aEvent.hasOwnProperty( 'originalEvent' ) === true ) {
						data = aEvent.originalEvent.state;
						a = self.createHistoryLink( data );

						p = $.Deferred( );

						p.fail( function( ) {
							var dir = ( data.hasOwnProperty( 'guid' ) === false || data.guid < self._history.guid ) ? 1 : -1;

							self._history.action = true;
							self._history.direction = dir;

							history.go( dir );
						} );

						p.done( function( ) {
							self._history.direction = null;
							self._history.restore = true;

							self.verbose( 'app: reloading history state', a );

							self.handleLinkClick( a, true );
						} );

						if ( self._module !== null ) {
							self._module.beforeUnload( p );
						}
					}
				} );
			} );

			window.onerror = function( aMessage, aFilename, aLine, aColumn, aError ) {
				if ( aError ) {
					StackTrace.fromError( aError ).then( function( stack ) {
						self.log( aMessage, aFilename, aLine, stack );
					} ).catch( function( ) {
						self.log( aMessage, aFilename, aLine, false );
					} );
				}
				else {
					self.log( aMessage, aFilename, aLine, false );
				}

				return true;
			};

			doc.on( 'keydown.cinder', function( aEvent ) {
				var el, tag, type,
					block = false;

				if ( aEvent.keyCode === 8 ) {
					block = true;

					el = aEvent.srcElement || aEvent.target;
					tag = el.tagName.toLowerCase( );

					if ( tag === 'input' ) {
						type = el.type.toLowerCase( );

						if ( type === 'text' || type === 'password' || type === 'file' || type === 'search' || type === 'email' || type === 'number' || type === 'date' ) {
							block = !!( el.readOnly || el.disabled );
						}
					}
					else if ( tag === 'textarea' ) {
						block = !!( el.readOnly || el.disabled );
					}
					else if ( el.isContentEditable === true ) {
						block = false;
					}

					el = $( 'div.element.selected' );

					if ( block === true && el.length > 0 && self._module !== null && $.isFunction( self._module.selectionAction ) === true && self._module._editable === true ) {
						self._module.selectionAction( 'delete' );
					}
				}

				if ( block === true ) {
					aEvent.preventDefault( );
				}
			} );

			// Bind to AB test system invoked from our VWO code
			this.$tests.on( 'test', function( aEvent, aTest ) {
				self.addSplitTest( aTest );
			} );
		},

		/**
		 * Method: enableIdleDetection
		 */

		enableIdleDetection: function( ) {
			var doc = $( document ),
				self = this;

			this.verbose( 'app: idle detection enabled' );

			doc.on( 'idle.mousemove idle.mousedown idle.touchstart idle.click idle.scroll idle.keypress', function( ) {
				if ( self._debounce.timer === null ) {
					self._debounce.timer = $.debounce( function( ) {
						self._debounce.timer = null;

						self.setCache( 'fingerprint', self._idle.fingerprint );
						self.setCache( 'idle', 0 );
					}, self._debounce.interval );
				}

				self._debounce.timer( );
			} );

			this._idle.timer = setInterval( this._idle.think, this._idle.interval );
		},

		/**
		 * Method: disableIdleDetection
		 */

		disableIdleDetection: function( ) {
			var doc = $( document );

			if ( this._idle.timer !== null ) {
				this.verbose( 'app: idle detection disabled' );

				doc.off( 'idle.mousemove idle.mousedown idle.touchstart idle.click idle.scroll idle.keypress' );

				clearInterval( this._idle.timer );

				this._idle.timer = null;
			}
		},

		/**
		 * Method: setupFormValidator
		 */

		setupFormValidator: function( ) {
			var self = this;

			$.validator.setDefaults( {
				errorElement: 'p',
				errorClass: 'error',
				focusInvalid: true,
				errorPlacement: function( aError, aInput ) {
					var error = $( aError ),
						input = $( aInput ),
						name = input.attr( 'name' ),
						form = input.closest( 'form' );

					// Ensure custom errors are added to the submitted object
					this.submitted[ name ] = error.text( );
					form.removeClass( 'form-validation-pending' );

					if ( input.hasClass( 'input-tooltip' ) === true ) {
						input.attr( 'title', error.text( ) );

						if ( input.is( '[data-original-title]' ) === true ) {
							// Required in order to change the contents of an existing tooltip
							input.tooltip( 'fixTitle' );
						}
						else {
							input.tooltip( {
								container: 'body',
								trigger: 'focus'
							} );
						}

						input.focus( );

						error.remove( );
					}
					else if ( input.parent( ).is( '.input-group' ) === true ) {
						error.insertAfter( input.parent( ) );
					}
					else {
						error.insertAfter( input );
					}
				},
				invalidHandler: function( aEvent, aValidator ) {
					var form = $( aValidator.currentForm ),
						modal_body = form.closest( '.modal-body' ),
						button;

					if ( modal_body.length > 0 ) {
						button = modal_body.parent( ).find( '.modal-footer .btn.btn-loading' ).first( );

						self.toggleButtonLoading( button, false );
					}
				},
				onkeyup: function( aElement, aEvent ) {
					// Copied from jQuery validate
					var excludedKeys = [ 16, 17, 18, 20, 35, 36, 37, 38, 39, 40, 45, 144, 225 ];

					if ( aElement.hasAttribute( 'data-original-title' ) === true && $( aElement ).hasClass( 'valid' ) === true ) {
						$( aElement ).tooltip( 'hide' );
					}

					if ( aEvent.which === 9 && this.elementValue( aElement ) === '' || $.inArray( aEvent.keyCode, excludedKeys ) !== -1 ) {
						return;
					}
					else if ( aElement.name in this.submitted || aElement.name in this.invalid ) {
						this.element( aElement );
					}
				},
				submitHandler: function( aForm ) {
					$( aForm ).addClass( 'form-validation-pending' );
					$( aForm ).find( 'input[data-original-title]' ).removeAttr( 'data-original-title' ).tooltip( 'destroy' );

					return true;
				},
				onfocusout: function( aElement ) {
					var el = $( aElement );

					// Make sure we don't trigger this on froala elements (including its hidden magic paste element)
					// Also ignore focus out for tooltip errors - we want to let Bootstrap handle showing/hiding the tooltips as much as possible
					if ( el.is( 'div.fr-element' ) === false && el.is( 'div[contenteditable="true"]' ) === false && aElement.hasAttribute( 'data-original-title' ) === false ) {
						// Copied from jQuery validate
						if ( !this.checkable( aElement ) && ( aElement.name in this.submitted || !this.optional( aElement ) ) ) {
							this.element( aElement );
						}
					}
				},
				unhighlight: function( aInput, aErrorClass ) {
					var input = $( aInput ),
						error_class = aErrorClass || '';

					// Remove tooltip
					if ( input.is( '[data-original-title]' ) === true ) {
						input.removeAttr( 'data-original-title' ).tooltip( 'destroy' );
					}

					// Default form validator behaviour
					input.removeClass( error_class );
				}
			} );
		},

		/**
		 * Redirect to the specified URL
		 *
		 * @param {Object} aRedirect
		 */

		redirect: function( aRedirect ) {
			var redirect = aRedirect || { },
				url = redirect.href || '',
				host = window.location.host.split( '.' ),
				subdomain = host[ 0 ],
				domain = host[ 1 ],
				suffix = host[ 2 ],
				redir = redirect.redirect || false,
				href, parts, a, i;

			if ( url[ 0 ] !== '/' && url.substr( 0, 2 ) !== '//' && url.indexOf( window.location.protocol ) === -1 ) {
				redir = true;
			}
			else {
				href = url.match( /\/\/([^\/,\s]+\.[^\/,\s]+?)(?=\/|,|\s|$|\?|#)/i );

				if ( href.length >= 1 ) {
					parts = href[ 1 ].split( '.' );

					if ( parts[ 0 ] !== subdomain || parts[ 1 ] !== domain || parts[ 2 ] !== suffix ) {
						redir = true;
					}
				}
			}

			if ( redir === true ) {
				if ( this._iframe !== false ) {
					if ( url.indexOf( '?' ) === -1 ) {
						url += '?_iframe=' + this._iframe;
					}
					else {
						url += '&_iframe=' + this._iframe;
					}
				}

				window.location.href = url;
			}
			else {
				a = document.createElement( 'a' );

				for ( i in redirect ) {
					if ( redirect.hasOwnProperty( i ) === true ) {
						a.setAttribute( i, redirect[ i ] );
					}
				}

				// Need to hide all modals on redirect
				$( 'body' ).find( '> div.modal' ).modal( 'hide' );

				this.handleLinkClick( a, true );

				a = null;
			}
		},

		/**
		 * Method: createHistoryEvent
		 * @param {Object} aData
		 */

		createHistoryEvent: function( aData ) {
			var data = { };

			data.guid = Date.now( );
			data.title = aData.title;
			data.url = aData.url;

			if ( aData.hasOwnProperty( 'container' ) === true ) {
				data.container = aData.container;
			}

			if ( aData.hasOwnProperty( 'action' ) === true && $.isPlainObject( aData.action ) === true ) {
				data.action = aData.action;
			}

			if ( aData.hasOwnProperty( 'scope' ) === true && aData.scope !== null ) {
				data.scope = aData.scope;
			}

			if ( aData.hasOwnProperty( 'success' ) === true ) {
				data.success = aData.success;
			}

			if ( aData.hasOwnProperty( 'error' ) === true ) {
				data.error = aData.error;
			}

			return data;
		},

		/**
		 * Method: createHistoryLink
		 * @param {Object} aData
		 */

		createHistoryLink: function( aData ) {
			var data = aData || { },
				a = document.createElement( 'a' );

			a.setAttribute( 'href', data.url );
			a.setAttribute( 'data-history', true );

			if ( this._history.loader !== null ) {
				a.setAttribute( 'data-loader', this._history.loader );

				this._history.loader = null;
			}

			if ( data.hasOwnProperty( 'container' ) === true ) {
				a.setAttribute( 'data-container', data.container );
			}

			if ( data.hasOwnProperty( 'action' ) === true && $.isPlainObject( data.action ) === true ) {
				if ( data.action.hasOwnProperty( 'method' ) === true ) {
					a.setAttribute( 'data-method', data.action.method );
				}

				if ( data.action.hasOwnProperty( 'target' ) === true ) {
					a.setAttribute( 'data-target', data.action.target );
				}
			}

			if ( data.hasOwnProperty( 'scope' ) === true ) {
				a.setAttribute( 'data-scope', data.scope );
			}

			if ( data.hasOwnProperty( 'success' ) === true ) {
				a.setAttribute( 'data-success', data.success );
			}

			if ( data.hasOwnProperty( 'error' ) === true ) {
				a.setAttribute( 'data-error', data.error );
			}

			return a;
		},

		/**
		 * Method: history
		 * @param {String} aType
		 * @param {Object} aData
		 */

		history: function( aType, aData ) {
			var type = aType || 'create',
				data = aData || { };

			if ( data.url.length > 0 && data.url[ 0 ] !== '/' ) {
				data.url = '/' + data.url;
			}

			document.title = data.title;
			document.body.scrollTop = document.documentElement.scrollTop = 0;

			if ( data.hasOwnProperty( '_source' ) === true ) {
				delete data._source;
			}

			data = this.createHistoryEvent( data );

			if ( this._history.restore === false ) {
				this._history.guid = data.guid;
			}
			else {
				this._history.restore = false;
			}

			if ( type === 'restore' ) {
				this.verbose( 'app: restoring history state' );
			}
			if ( type === 'replace' ) {
				this.verbose( 'app: replacing history state' );

				window.history.replaceState( data, data.title, data.url );
			}
			else if ( type === 'create' ) {
				this.verbose( 'app: creating history state' );

				window.history.pushState( data, data.title, data.url );
			}

			if ( window.hasOwnProperty( 'dataLayer' ) === true ) {
				window.dataLayer.push( {
					'event': 'pageview',
					'virtualUrl': data.url
				} );
			}

			return this;
		},

		/**
		 * Method: verbose
		 */

		verbose: function( ) {
			if ( this._verbose === true ) {
				console.log.apply( console, arguments ); // eslint-disable-line no-console
			}

			return this;
		},

		/**
		 * Method: error
		 * @param {Object} aError
		 */

		error: function( aError ) {
			var err = aError || { },
				show = false,
				now = Date.now( ),
				last = false,
				duplicate = false,
				force = [
					'froala.',
					'editor.js',
					'element.js'
				],
				recent, i, len, j, len2;

			if ( this._errors.length > 1 ) {
				last = this._errors[ this._errors.length - 1 ];

				if ( last.url === err.url && last.message === err.message && last.file_path === err.file_path && last.line_number === err.line_number ) {
					duplicate = true;
				}
			}

			if ( duplicate === false ) {
				this._errors.push( err );
			}

			if ( this._errors.length > 10 ) {
				this._errors.unshift( );
			}

			recent = this._errors.filter( function( val ) {
				return ( ( val.created_datetime + ( 30 * 1000 ) ) >= now );
			} );

			if ( recent.length > 5 ) {
				show = true;
			}

			if ( this._verbose === true ) {
				show = true;
			}
			else if ( last !== false && duplicate === true ) {
				show = false;
			}
			else if ( err.file_path.indexOf( '/ping?callback=' ) !== -1 || err.file_path.indexOf( '/export/thumbnail/' ) !== -1 ) {
				show = false;
			}

			if ( show !== true && err.hasOwnProperty( 'stack_trace' ) === true ) {
				for ( i = 0, len = err.stack_trace.length; i < len; i++ ) {
					for ( j = 0, len2 = force.length; j < len2; j++ ) {
						if ( err.stack_trace[ i ].fileName.indexOf( force[ j ] ) !== -1 ) {
							show = true;

							break;
						}
					}
				}
			}

			if ( show === true ) {
				if ( this._module !== null ) {

					this._user_monitoring.action( 'Error', {
						error: aError
					} );

					this._module.error( 'An error has occurred. ' + this.getData( 'system.options.support_message' ) );
				}
			}
		},

		/**
		 * Method: message
		 * @param {String} aMessage
		 * @param {String} aKey
		 * @param {String} aClasses
		 */

		message: function( aMessage, aKey, aClasses ) {
			var msg = aMessage || false,
				key = aKey || 'flashdata',
				classes = aClasses || false,
				selector = this.getData( 'system.options.' + key + '_container' ),
				data = this.getData( 'module.data' ),
				el;

			if ( msg !== false ) {
				el = $( data.container ).find( selector );

				if ( el.length === 0 ) {
					el = $( selector );
				}

				if ( classes !== false ) {
					if ( classes === 'error' ) {
						classes = 'danger';
					}

					el.html( '<div class="alert alert-' + classes + '" role="alert">' + msg + '</div>' ).show( );
				}
				else {
					el.html( msg ).show( );
				}

				this.bindLinks( el );
			}
			else {
				this.clearMessage( key );
			}
		},

		/**
		 * showFormErrors
		 * @param {JSONObject} aErrors
		 */

		showFormErrors: function( aErrors ) {
			var form = $( 'form.form-validation-pending' ),
				errors = aErrors || { },
				i, input, button;

			for ( i in errors ) {
				if ( errors.hasOwnProperty( i ) === true ) {
					input = form.find( '[name="' + i + '"]' );

					if ( input.length === 0 ) {
						input = $( '[name="' + i + '"]' );
						form = input.closest( 'form' );
					}

					if ( form.closest( '.modal-body' ).length !== 0 ) {
						button = form.closest( '.modal-body' ).parent( ).find( '.modal-footer .btn.btn-loading' ).first( );

						this.toggleButtonLoading( button, false );
					}

					input.focus( );

					form.validate( ).showErrors( errors );

					return;
				}
			}
		},

		/**
		 * Remove any pending form errors
		 */

		hideFormErrors: function( ) {
			var form = $( 'form.form-validation-pending' );

			if ( form.length > 0 ) {
				form.removeClass( 'form-validation-pending' );
				form.validate( ).resetForm( );
			}
		},

		/**
		 * Method: clearMessage
		 * @param {String} aKey
		 */

		clearMessage: function( aKey ) {
			var key = aKey || 'flashdata',
				selector = this.getData( 'system.options.' + key + '_container' ),
				data = this.getData( 'module.data' ),
				el;

			if ( data !== false ) {
				el = $( data.container );
			}
			else {
				el = $( key );
			}

			el.find( selector ).hide( ).empty( );
		},

		/**
		 * Method: log
		 * @param {String} aMessage
		 * @param {String} aFilename
		 * @param {Int} aLine
		 * @param {Array} aTrace
		 */

		log: function( aMessage, aFilename, aLine, aTrace ) {
			var msg = aMessage || 'SyntaxError: Unknown',
				file = aFilename || 'unknown',
				line = aLine || 0,
				trace = aTrace || [ ],
				user = this.getData( 'system.user' ),
				i, len, data,
				log = true,
				self = this;

			for ( i = 0, len = trace.length; i < len; i++ ) {
				if ( trace[ i ].fileName.indexOf( '/system/js/app.js' ) !== -1 && trace[ i ].functionName === 'error' ) {
					log = false;

					break;
				}
			}

			if ( msg === 'Access is denied.' ) {
				log = false;
			}

			// Grammarly web extension will trigger this periodically (but is not of consequence to us)
			if ( msg === 'ResizeObserver loop limit exceeded' ) {
				log = false;
			}

			if ( log === true ) {
				data = {
					url: window.location.href,
					message: msg,
					file_path: file,
					line_number: line,
					created_datetime: Date.now( )
				};

				if ( trace.length > 0 ) {
					data.stack_trace = JSON.stringify( trace );
				}
				else {
					data.stack_trace = 'not available';
				}

				if ( typeof this._datadog === 'undefined' ) {
					this.getConduit( ).ajax( {
						url: '/error/javascript',
						data: data,
						beforeSend: function( ) {
							self.verbose( '(╯°□°）╯︵ ┻━┻ ' + msg.replace( 'SyntaxError: ', '' ) + ', ' + file + ' line ' + line );
							self.verbose( 'stack trace:', trace );
						},
						success: function( ) {
							data.stack_trace = trace;

							if ( self._display_errors === true ) {
								self.error( data );
							}
						}
					} );

					return;
				}

				if ( user !== false ) {
					data.account = {
						account_id: user.account_id,
						account_name: user.account_name,
						subdomain: user.account_subdomain
					};
				}

				if ( typeof this._datadog !== 'undefined' && typeof this._datadog.logger !== 'undefined' ) {
					this._datadog.logger.log( msg, data, 'error' );
				}

				if ( this._display_errors === true ) {
					this.error( data );
				}
			}
		},

		/**
		 * Method: info
		 *
		 * Send data information to datadog
		 *
		 * @param {String} aName
		 */

		info: function( aName ) {
			var name = aName || 'default',
				data = { },
				user = this.getData( 'system.user' );

			data = Logger.create( name );

			if ( user !== false ) {
				data.account = {
					account_id: user.account_id,
					account_name: user.account_name,
					subdomain: user.account_subdomain
				};
			}

			if ( this._datadog !== undefined ) {
				Logger.publish( this._datadog, data, 'info' );
			}
		},

		/**
		 * Method: extend
		 * @param {Object} aDestination
		 * @param {Object} aSource
		 */

		extend: function( aDestination, aSource ) {
			var i;

			for ( i in aSource ) {
				if ( aSource.hasOwnProperty( i ) === true ) {
					aDestination[ i ] = aSource[ i ];
				}
			}

			return aDestination;
		},

		/**
		 * Method: request
		 * @param {Object} aOptions
		 */

		request: function( aOptions ) {
			var options = aOptions || { };

			return $.extend( true, {
				system: false,
				redirect: false,
				history: false,
				title: null,
				url: '/',
				name: false,
				container: null,
				scope: null,
				infinite: false,
				action: {
					method: 'update',
					target: 'container'
				},
				view: {
					path: false,
					hash: false,
					html: null,
					css: [ ],
					js: [ ],
					fonts: [ ],
					data: { },
					show_nav: null
				}
			}, options );
		},

		/**
		 * Method: isUnloading
		 */

		isUnloading: function( ) {
			var unloading = true;

			if ( 'activeElement' in document && document.activeElement && document.activeElement.hasAttribute( 'href' ) && document.activeElement.getAttribute( 'href' ).indexOf( 'mailto:' ) !== -1 ) {
				unloading = false;
			}

			return unloading;
		},

		/**
		 * Method: unload
		 * @param {Object} aModule
		 */

		unload: function( aModule ) {
			var module = aModule || null,
				link, fp, ff, el,
				i, len;

			if ( module !== null ) {
				if ( module.hasOwnProperty( 'view' ) === true ) {
					if ( module.view.hasOwnProperty( 'fonts' ) === true ) {
						for ( i = 0, len = module.view.fonts.length; i < len; i++ ) {
							link = module.view.fonts[ i ];

							this.verbose( 'app: unload ' + link );

							fp = link.substring( 0, link.indexOf( ',' ) );

							ff = link.substring( link.indexOf( '[' ) + 1, module.lastIndexOf( ']' ) );
							ff = ff.replace( ',', '|' );
							ff = encodeURIComponent( ff );

							el = $( 'link[href*="' + fp + '"][href*="' + ff + '"]' );

							el.prop( 'disabled', true );
							el.remove( );

							requirejs.undef( 'system/js/require.webfont!' + link );
						}
					}

					if ( module.view.hasOwnProperty( 'css' ) === true ) {
						for ( i = 0, len = module.view.css.length; i < len; i++ ) {
							link = module.view.css[ i ].substr( 0, module.view.css[ i ].indexOf( '.' ) );

							this.verbose( 'app: unload ' + link.replace( 'css!', '' ) );

							el = $( 'link[href*="' + link + '.css"]' );

							el.prop( 'disabled', true );
							el.remove( );

							requirejs.undef( 'system/js/require.css.min!' + link );
						}
					}
				}

				this.verbose( 'app: unload ' + module.name );

				requirejs.undef( module.name );

				module = null;
			}
		},

		/**
		 * Method: load
		 * @param {Object} aData
		 */

		load: function( aData ) {
			var data = aData || { },
				cache = this.getData( 'system.options.enable_cache' ),
				link, el, div, i, len,
				dependencies = [ ],
				options = { },
				module = null,
				redir = false,
				self = this;

			if ( data.hasOwnProperty( 'action' ) === true && $.isPlainObject( data.action ) === true ) {
				this.setData( 'module.data.action', false );
			}

			data = $.extend( true, this.request( ), data );

			this._loaded = -1;

			if ( this._module !== null ) {
				link = this.getData( 'module.data.name' );

				if ( link !== false && link.name !== false && data.name !== false ) {
					redir = true;

					module = $.extend( true, { }, this.getData( 'module.data' ) );

					el = $( 'link[href*="system/css/loaded.css"]' );

					el.prop( 'disabled', true );
					el.remove( );

					requirejs.undef( 'system/js/require.css.min!system/css/loaded' );

					this.$templates.find( '> div[data-module="true"]' ).remove( );
				}
			}

			if ( data.hasOwnProperty( 'templates' ) === true ) {
				div = document.createElement( 'div' );
				div.setAttribute( 'data-module', true );

				for ( i = 0, len = data.templates.length; i < len; i++ ) {
					div.insertAdjacentHTML( 'beforeend', data.templates[ i ] );
				}

				this.$templates.append( div );
			}

			if ( data.view !== false ) {
				for ( i = 0, len = data.view.fonts.length; i < len; i++ ) {
					link = 'font!' + data.view.fonts[ i ];

					this.verbose( 'app: load ' + link.replace( 'font!', '' ) );

					dependencies.push( link );
				}

				if ( cache === true && data.view.path !== false ) {
					this.verbose( 'app: load ' + data.view.path );

					dependencies.push( data.view.path );
				}

				if ( module !== null && module.hasOwnProperty( 'view' ) === true && $.isPlainObject( module.view ) === true && module.view.hasOwnProperty( 'css' ) === true && module.view.css.length > 0 ) {
					for ( i = 0, len = module.view.css.length; i < len; i++ ) {
						if ( data.view.css.indexOf( module.view.css[ i ] ) !== -1 ) {
							module.view.css.splice( i, 1 );
							i--;
							len--;
						}
					}
				}

				len = data.view.css.length;

				if ( len > 0 ) {
					for ( i = 0; i < len; i++ ) {
						link = 'css!' + data.view.css[ i ].substr( 0, data.view.css[ i ].indexOf( '.' ) );

						this.verbose( 'app: load ' + link.replace( 'css!', '' ) );

						dependencies.push( link );
					}

					this.verbose( 'app: load system/css/loaded' );

					dependencies.push( 'css!system/css/loaded' );
				}
				else {
					this._loaded += 1;
				}
			}
			else {
				this._loaded += 1;
			}

			if ( data.name !== false ) {
				options.parent = this;
				options.url = data.url;
				options.base_url = data.base_url;
				options.request_url = data.request_url;

				data.redirect = redir;

				this.verbose( 'app: load ' + data.name );

				this._timer._callbacks.stop = function( ) {
					self.verbose( 'app: waited ' + self._timer.runtime( ) + 'ms for includes' );

					self._unload = module;
					self._unloading = false;

					self.setPendingData( data );
				};

				dependencies.unshift( data.name );

				this._loaded = -1;
				this._unloading = true;

				require( dependencies, function( Module ) {
					var i;

					if ( $.FE !== undefined ) {
						// Reset $.FE to use the default values
						for ( i in self._FE ) {
							if ( self._FE.hasOwnProperty( i ) === true ) {
								if ( typeof self._FE[ i ] === 'object' ) {
									if ( self._FE[ i ] === null ) {
										$.FE[ i ] = null;
									}
									else {
										$.FE[ i ] = $.extend( $.FE[ i ], self._FE[ i ] );
									}
								}
							}
						}

						// Update _FE for the next reset
						for ( i in $.FE ) {
							if ( $.FE.hasOwnProperty( i ) === true ) {
								if ( typeof $.FE[ i ] === 'object' ) {
									if ( $.FE[ i ] === null ) {
										self._FE[ i ] = null;
									}
									else {
										self._FE[ i ] = $.extend( { }, $.FE[ i ] );
									}
								}
							}
						}
					}

					self.setModule( new Module( options ) );
					self._loaded += 1;

					self._timer.start( );
				}, requireError );
			}
			else if ( dependencies.length > 0 ) {
				this._timer._callbacks.stop = function( ) {
					self.verbose( 'app: waited ' + self._timer.runtime( ) + 'ms for includes' );

					self._unload = module;
					self._unloading = false;

					self.setPendingData( data );
				};

				this._loaded = -1;
				this._unloading = true;

				require( dependencies, function( ) {
					self._loaded += 1;

					self._timer.start( );
				}, requireError );
			}
			else if ( this._module !== null ) {
				if ( this._timer.running( ) === true ) {
					this._timer.stop( );
				}
				else {
					this._loaded = -1;
					this._unload = module;
					this._unloading = false;

					this.setPendingData( data );
				}
			}
		},

		/**
		 * Method: setModule
		 * @param {Object} aModule
		 */

		setModule: function( aModule ) {
			if ( this._module !== null ) {
				this.verbose( 'app: unloading module' );

				// unload tutorial
				if ( this._tutorial !== null ) {
					this._tutorial.unload( );

					this._tutorial = null;
				}

				this._module.unload( );
				this._module = null;
			}

			this._module = aModule;
			this._errors = [ ];
		},

		/**
		 * Method: bindModule
		 * @param {DOMelement} aContainer
		 */

		bindModule: function( aContainer ) {
			if ( this._module !== null ) {
				this._module.bindMainEventListeners( aContainer );
			}
		},

		/**
		 * Method: setPendingData
		 * @param {Object} aData
		 */

		setPendingData: function( aData ) {
			var data = aData || { },
				module, view;

			this.verbose( 'app: set pending data', data );

			module = this.getData( 'module.data.name' );

			if ( module !== false && data.name === false ) {
				delete data.name;
			}

			if ( data.hasOwnProperty( 'name' ) === true && data.name !== false && data.hasOwnProperty( 'view' ) === true && $.isPlainObject( data.view ) === true ) {
				if ( data.view.hasOwnProperty( 'css' ) === true && Array.isArray( data.view.css ) === true && data.view.css.length > 0 ) {
					this.setData( 'module.data.view.css', false );
				}

				if ( data.view.hasOwnProperty( 'js' ) === true && Array.isArray( data.view.js ) === true && data.view.js.length > 0 ) {
					this.setData( 'module.data.view.js', false );
				}
			}

			if ( data.hasOwnProperty( 'system' ) === true && data.system === false && data.hasOwnProperty( 'redirect' ) === true && data.redirect === true ) {
				this.setData( 'module.data', false );
			}

			this.setData( 'module.data', data );

			if ( data.history === true ) {
				this.history( 'restore', data );
			}
			else if ( data.system === true ) {
				this.history( 'replace', data );
			}
			else if ( data.redirect === true ) {
				this.history( 'create', data );
			}

			if ( data.hasOwnProperty( 'version' ) === true ) {
				if ( this._version === false ) {
					this._version = data.version;
				}
				else if ( this._version !== data.version ) {
					this._module.notification( {
						body: 'A new version is available. Please <a href="javascript:;" onclick="window.location.reload(true);">refresh the page</a> to apply the update.',
						classes: 'app-version',
						delay: 0
					} );
				}
			}

			if ( data.hasOwnProperty( 'display_errors' ) === true ) {
				this._display_errors = data.display_errors;
			}

			if ( data.hasOwnProperty( 'csrf' ) === true ) {
				if ( this._csrf === false ) {
					this._csrf = data.csrf;

					this.verbose( 'app: creating access token' );
				}
				else {
					this._csrf.value = data.csrf.value;

					this.verbose( 'app: updating access token' );
				}
			}

			if ( data.view.path !== false ) {
				view = this.getView( data.view.path, data.view.hash );

				if ( view === false ) {
					if ( data.view.hasOwnProperty( 'invalidate' ) === true ) {
						this.verbose( 'app: invalidate cached view ' + data.view.path );

						this.invalidateView( data.view.path );
					}

					this.createView( {
						url: data.url.replace( /\/[0-9].*/, '' ),
						path: data.view.path,
						hash: data.view.hash,
						html: data.view.html
					} );
				}

				// show both navs
				if ( data.view.show_nav === true ) {
					if ( this.$container.hasClass( 'hide-left-nav' ) === true ) {
						this.$container.removeClass( 'hide-left-nav' );
					}

					if ( this.$container.hasClass( 'hide-top-nav' ) === true ) {
						this.$container.removeClass( 'hide-top-nav' );
					}

					if ( this.$container.hasClass( 'hide-nav-ribbon' ) === true ) {
						this.$container.removeClass( 'hide-nav-ribbon' );
					}
				}
				// hide both navs
				else if ( data.view.show_nav === false ) {
					if ( this.$container.hasClass( 'hide-left-nav' ) === false ) {
						this.$container.addClass( 'hide-left-nav' );
					}

					if ( this.$container.hasClass( 'hide-top-nav' ) === false ) {
						this.$container.addClass( 'hide-top-nav' );
					}

					if ( this.$container.hasClass( 'hide-nav-ribbon' ) === false ) {
						this.$container.addClass( 'hide-nav-ribbon' );
					}
				}
				// show top nav
				else if ( data.view.show_nav === 'top' ) {
					if ( this.$container.hasClass( 'hide-left-nav' ) === false ) {
						this.$container.addClass( 'hide-left-nav' );
					}

					if ( this.$container.hasClass( 'hide-top-nav' ) === true ) {
						this.$container.removeClass( 'hide-top-nav' );
					}

					if ( this.$container.hasClass( 'hide-nav-ribbon' ) === true ) {
						this.$container.removeClass( 'hide-nav-ribbon' );
					}
				}
				// show left nav
				else if ( data.view.show_nav === 'left' ) {
					if ( this.$container.hasClass( 'hide-left-nav' ) === true ) {
						this.$container.removeClass( 'hide-left-nav' );
					}

					if ( this.$container.hasClass( 'hide-top-nav' ) === false ) {
						this.$container.addClass( 'hide-top-nav' );
					}

					if ( this.$container.hasClass( 'hide-nav-ribbon' ) === false ) {
						this.$container.addClass( 'hide-nav-ribbon' );
					}
				}

				this.renderView( data );
			}
			else {
				if ( data.hasOwnProperty( '_strings' ) === true ) {
					this.setStrings( data._strings );

					if ( data.hasOwnProperty( '_stringdata' ) === true ) {
						this.updateViewStrings( data._stringdata );
					}
					else {
						this.updateViewStrings( );
					}
				}

				this.callback( data );
			}

			this._cache.available( );

			this.verbose( '~===~' );

			return this;
		},

		/**
		 * Method: callback
		 * @param {Object} aData
		 */

		callback: function( aData ) {
			var data = aData || { },
				scope, container, source,
				a;

			if ( data.hasOwnProperty( '_flashdata' ) === true ) {
				if ( data._flashdata.hasOwnProperty( 'message' ) === true ) {
					this.verbose( 'app: flash message' );

					this.message( data._flashdata.message );

					this.removeData( 'module.data._flashdata' );
				}
			}

			if ( data.hasOwnProperty( 'extra_request_url' ) === true ) {
				a = document.createElement( 'a' );
				a.setAttribute( 'href', data.extra_request_url );
				// Use a fake container so it doesn't show the page loader
				a.setAttribute( 'data-container', '#pyFake' );

				this.handleLinkClick( a );
			}

			if ( this._module !== null ) {
				container = $( data.container );

				if ( container.length === 0 ) {
					container = this._module.getContainer( );
				}

				this.hideLoader( container );
				this.hideFormErrors( );

				if ( data.hasOwnProperty( '_source' ) === true ) {
					source = data._source;

					delete data.source;
				}
				else {
					source = $( );
				}

				if ( data.hasOwnProperty( '_logindata' ) === true ) {
					this._module.handleUserLogin( data._logindata );

					this.removeData( 'module.data._logindata' );
				}

				if ( data.hasOwnProperty( '_aliasdata' ) === true ) {
					this._module.handleUserAlias( data._aliasdata );

					this.removeData( 'module.data._aliasdata' );
				}

				if ( data.hasOwnProperty( '_eventdata' ) === true ) {
					this._module.handleEvents( data._eventdata );

					this.removeData( 'module.data._eventdata' );
				}

				if ( data.hasOwnProperty( '_termschanged' ) === true ) {
					this._module.triggerTermsModal( data._termschanged );

					this.removeData( 'module.data._termschanged' );
				}

				if ( data.hasOwnProperty( '_planupgrademodal' ) === true && data.view.data.mode !== 'suspended' ) {
					this._module.triggerPlanUpgradeModal( data._planupgrademodal );

					this.removeData( 'module.data._planupgrademodal' );
				}

				if ( data.hasOwnProperty( '_tutorial_step' ) === true ) {
					// Initialize tutorial on first step received
					if ( this._tutorial === null ) {
						this._tutorial = new Tutorial( {
							parent: this
						} );
					}

					this._tutorial.setStep( data._tutorial_step );
					this._tutorial.substep( );

					this.removeData( 'module.data._tutorial_step' );
				}

				if ( source.length === 1 && source[ 0 ].hasAttribute( 'data-infinite' ) === true ) {
					this.updateInfiniteMarker( source, data );
				}

				if ( data.hasOwnProperty( 'modal' ) === true ) {
					if ( data.hasOwnProperty( 'scope' ) === true && data.scope !== null ) {
						scope = $( data.scope );

						if ( scope.length > 0 ) {
							scope.trigger( data.modal, [
								{
									source: source,
									container: container,
									data: data
								}
							] );
						}
						else {
							this.verbose( 'app: modal ' + data.modal + ' skipped (scope not found)' );
						}
					}
					else if ( $.isFunction( this._module[ data.modal ] ) === true ) {
						this.verbose( 'app: modal ' + data.modal );

						this._module[ data.modal ]( {
							source: source,
							container: container,
							data: data
						} );
					}
					else {
						this.verbose( 'app: modal ' + data.modal + ' skipped (method not found)' );
					}
				}
				else if ( data.hasOwnProperty( 'success' ) === true && data.success !== 'init' ) {
					if ( data.action.target !== 'container' ) {
						container = container.find( data.action.target );
					}

					if ( data.infinite === true && data.action.method === 'update' ) {
						container = container.children( );
					}
					else if ( data.action.hasOwnProperty( 'range_start' ) === true ) {
						if ( data.action.hasOwnProperty( 'range_end' ) === true ) {
							if ( data.action.method === 'prepend' ) {
								container = container.children( ).slice( data.action.range_start, data.action.range_end + 1 );
							}
							else {
								container = container.parent( ).children( ).slice( data.action.range_start, data.action.range_end + 1 );
							}
						}
						else {
							container = container.children( ).slice( data.action.range_start );
						}
					}

					if ( data.scope !== null ) {
						scope = $( data.scope );

						if ( scope.length > 0 ) {
							this.verbose( 'app: success ' + data.success + ' on ' + data.scope );

							scope.trigger( data.success, [
								{
									source: source,
									container: container,
									data: data
								}
							] );
						}
						else {
							this.verbose( 'app: success ' + data.success + ' skipped (scope not found)' );
						}
					}
					else if ( $.isFunction( this._module[ data.success ] ) === true ) {
						this.verbose( 'app: success ' + data.success );

						this._module[ data.success ]( {
							source: source,
							container: container,
							data: data
						} );
					}
					else {
						this.verbose( 'app: success ' + data.success + ' skipped (method not found)' );
					}
				}
			}
		},

		/**
		 * Method: getData
		 * @param {String} aKey
		 */

		getData: function( aKey ) {
			return this._model.get( aKey );
		},

		/**
		 * Method: setData
		 * @param {String} aKey
		 * @param {Mixed} aData
		 */

		setData: function( aKey, aData ) {
			this._model.set( aKey, aData );

			return this;
		},

		/**
		 * Method: removeData
		 * @param {String} aKey
		 */

		removeData: function( aKey ) {
			this._model.remove( aKey );

			return this;
		},

		/**
		 * Method: getView
		 * @param {String} aPath
		 * @param {String} aHash
		 */

		getView: function( aPath, aHash ) {
			var view = this._view.get( aPath, aHash ),
				cache;

			if ( view === false ) {
				cache = this.getCache( aPath + '|' + aHash );

				if ( cache !== false ) {
					this.verbose( 'app: view cache found' );

					view = this._view.create( cache );
				}
			}
			else {
				this.verbose( 'app: view file found' );
			}

			return view;
		},

		/**
		 * Method: getDataViews
		 * @param {String} aUrl
		 */

		getDataViews: function( aUrl ) {
			var url = aUrl || '',
				a, views;

			if ( url.indexOf( 'http' ) !== -1 ) {
				a = document.createElement( 'a' );
				a.href = url;

				url = a.pathname + a.search;
				url = url.substring( 1 );

				a = null;
			}
			else if ( url.charAt( 0 ) === '/' ) {
				url = url.substring( 1 );
			}

			url = url.replace( /\/[0-9].*/, '' );

			views = this.getData( 'system.views.' + url );

			return views;
		},

		/**
		 * Method: getCachedViews
		 */

		getCachedViews: function( ) {
			var cache = this._cache.getAll( ),
				keys = [ ],
				i, len, j;

			for ( i = 0, len = cache.length; i < len; i++ ) {
				if ( cache[ i ]._key.indexOf( '.dust|' ) !== -1 ) {
					if ( keys[ cache[ i ].url ] === undefined ) {
						keys[ cache[ i ].url ] = [ ];
					}

					keys[ cache[ i ].url ].push( cache[ i ].path + '|' + cache[ i ].hash );
				}
			}

			for ( j in keys ) {
				if ( keys.hasOwnProperty( i ) === true ) {
					this.setData( 'system.views.' + j, keys[ j ] );
				}
			}
		},

		/**
		 * Method: createView
		 * @param {Object} aView
		 */

		createView: function( aView ) {
			var dkey = 'system.views.' + aView.url,
				vkey = aView.path + '|' + aView.hash;

			this.verbose( 'app: creating view' );

			if ( this.getData( dkey ) === false ) {
				this.setData( dkey, [ ] );
			}

			this.setData( dkey, [ vkey ] );

			this.setCache( vkey, aView );

			this._view.create( aView );
		},

		/**
		 * Method: renderView
		 * @param {Object} aData
		 * @param {Function} aCallback
		 */

		renderView: function( aData, aCallback ) {
			var data = aData || { },
				path = data.view.path,
				container = $( data.container ),
				callback = aCallback || function( aContainer ) { },
				self = this;

			this._view.render( path, data.view.data, function( output ) {
				if ( data.system === true ) {
					self.getCachedViews( );

					self.bindLinks( self.$container );
					self.bindForms( self.$container );
				}

				self.injectView( data, container, output );
				self.callback( data );

				if ( self._module !== null ) {
					self._module.autofocus.apply( self._module, [ container ] );
				}

				callback( container );
			} );
		},

		/**
		 * Method: injectView
		 * @param {Object} aData
		 * @param {DOMelement} aContainer
		 * @param {String} aContent
		 */

		injectView: function( aData, aContainer, aContent ) {
			var data = aData || { },
				container = $( aContainer ),
				content = aContent || '',
				range, frag, el, table, tbody, div, parent, i, len;

			if ( content.substr( 0, 3 ) === '<tr' ) {
				table = document.createElement( 'table' );
				tbody = document.createElement( 'tbody' );

				table.appendChild( tbody );
				$( tbody ).append( content );

				frag = document.createDocumentFragment( );
				frag.appendChild( table );

				el = frag.firstChild.firstChild.childNodes;
			}
			else {
				range = document.createRange( );
				range.selectNode( document.body );

				el = range.createContextualFragment( content );

				range.detach( );
			}

			this.unload( this._unload );
			this._unload = null;

			if ( data.hasOwnProperty( 'modal' ) === true ) {
				this.$modal.empty( ).append( el );

				container = this.$modal;
			}
			else if ( data.action.method === 'update' ) {
				if ( data.action.target !== 'container' ) {
					container = container.find( data.action.target );
				}

				if ( this._module !== null && container.children( ).length > 0 ) {
					this._module.unbind( container );
				}

				container.html( el );
			}
			else {
				if ( data.action.target !== 'container' ) {
					container = container.find( data.action.target );
				}

				if ( data.action.method === 'replace' ) {
					if ( this._module !== null && container.children( ).length > 0 ) {
						this._module.unbind( container );
					}

					if ( container.is( 'tr' ) === true || container.is( 'li' ) === true ) {
						parent = container.parent( );
						i = container.index( );

						container.replaceWith( el );

						container = parent.children( ).eq( i );
					}
					else {
						div = document.createElement( 'div' );
						div.setAttribute( 'class', 'py-wrapper' );
						div.appendChild( el );

						container.replaceWith( div );

						el = $( 'div.py-wrapper' );

						container = el.parent( );

						el.children( ).unwrap( );
					}
				}
				else if ( data.action.method === 'prepend' ) {
					el = $( el );

					container.prepend( el );

					data.action.range_start = 0;
					i = el.children( ).length;

					if ( i > 1 ) {
						data.action.range_end = el.children( ).length - 1;
					}
					else {
						data.action.range_end = 1;
					}

					container = container.children( ).slice( data.action.range_start, data.action.range_end );
				}
				else if ( data.action.method === 'append' ) {
					data.action.range_start = container.find( '> *:not(.overlay)' ).length;

					container.append( el );

					container = container.children( ).not( '.overlay' ).slice( data.action.range_start );
				}
				else if ( data.action.method === 'before' ) {
					el = $( el );
					len = el.children( ).length;
					i = container.index( );

					el.insertBefore( container );

					container = container.parent( ).children( ).slice( i, i + len );

					data.action.range_start = container.first( ).index( );
					data.action.range_end = container.last( ).index( );
				}
				else if ( data.action.method === 'after' ) {
					el = $( el );
					len = el.children( ).length;
					i = container.index( ) + 1;

					el.insertAfter( container );

					container = container.parent( ).children( ).slice( i, i + len );

					data.action.range_start = container.first( ).index( );
					data.action.range_end = container.last( ).index( );
				}
			}

			frag = el = range = null;

			if ( data.hasOwnProperty( '_strings' ) === true ) {
				this.setStrings( data._strings );

				if ( data.hasOwnProperty( '_stringdata' ) === true ) {
					this.updateViewStrings( data._stringdata );
				}
				else {
					this.updateViewStrings( );
				}
			}
			else if ( content.indexOf( 'data-string="' ) !== -1 ) {
				if ( data.hasOwnProperty( '_stringdata' ) === true ) {
					this.updateViewStrings( data._stringdata );
				}
				else {
					this.updateViewStrings( );
				}
			}

			this.bindLinks( container );
			this.bindForms( container );

			if ( this.$container.hasClass( 'hidden' ) ) {
				this.$container.removeClass( 'hidden' );
			}

			if ( data.hasOwnProperty( 'name' ) === true && data.name !== false ) {
				this.bindModule( container );
			}
		},

		/**
		 * Method: invalidateView
		 * @param {String} aPath
		 */

		invalidateView: function( aPath ) {
			var keys = this._cache.getKeys( ),
				i, len;

			for ( i = 0, len = keys.length; i < len; i++ ) {
				if ( keys[ i ].indexOf( aPath ) !== -1 ) {
					this._cache.remove( keys[ i ] );
				}
			}
		},

		/**
		 * Method: getCache
		 * @param {String} aKey
		 */

		getCache: function( aKey ) {
			return this._cache.get( aKey );
		},

		/**
		 * Method: setCache
		 * @param {String} aKey
		 * @param {String} aContent
		 */

		setCache: function( aKey, aContent ) {
			this._cache.set( aKey, aContent );

			return this;
		},

		/**
		 * Method: removeCache
		 * @param {String} aKey
		 */

		removeCache: function( aKey ) {
			this._cache.remove( aKey );

			return this;
		},

		/**
		 * Method: clearCache
		 */

		clearCache: function( ) {
			this.removeData( 'system.views' );
			this.setData( 'system.views', [ ] );

			this._view.empty( );

			this._cache.empty( );
			this._cache.available( );
		},

		/**
		 * Method: getConduit
		 * @param {String} aName
		 */

		getConduit: function( aName ) {
			var name = aName || Math.random( ).toString( 36 ).substr( 2 );

			if ( this._conduit.hasOwnProperty( name ) === false ) {
				this._conduit[ name ] = new Conduit( {
					name: name,
					parent: this
				} );
			}

			return this._conduit[ name ];
		},

		/**
		 * Method: getEmitter
		 */

		getEmitter: function( ) {
			return this._emitter;
		},

		/**
		 * Animate button with a wiggle effect
		 *
		 * @param {DOMElement} 	aButton 	Button to wiggle
		 */

		wiggleButton: function( aButton ) {
			var el = $( aButton );

			el.velocity( {
				rotateZ: '-2deg'
			}, {
				duration: 100,
				easing: 'easeOut',
				complete: function( ) {
					el.velocity( {
						rotateZ: '2deg'
					}, {
						duration: 150,
						complete: function( ) {
							el.velocity( {
								rotateZ: '0deg'
							}, {
								duration: 600,
								easing: 'easeOutBounce'
							} );
						}
					} );
				}
			} );
		},

		/**
		 * Toggles loading for aButton and enables/disables other buttons depending on form/modal parents
		 *
		 * @param {DOMElement} 	aButton 	Button that is loading
		 * @param {Boolean}		aLoading 	True for show loader, false for hide
		 */

		toggleButtonLoading: function( aButton, aLoading ) {
			var button = $( aButton ),
				loading = aLoading || false,
				parent, buttons;

			if ( button.length !== 0 ) {
				button.loading( loading );

				parent = button.closest( 'form' );

				if ( parent.length === 0 || parent.parent( ).is( 'div.modal-body' ) === true ) {
					parent = button.closest( 'div.modal-content > div.modal-footer' );
				}

				buttons = parent.find( 'button.btn, a.btn' );

				if ( loading === true ) {
					buttons.disable( );
				}
				else {
					buttons.enable( );
				}
			}
		},

		/**
		 *  Returns the available loader container to be used
		 *
		 *  @param {JSONObject}	aOptions		In case a link triggered the container load
		 */
		getLoaderContainerAvailable: function( aOptions ) {
			var options = aOptions || { };

			if ( options.hasOwnProperty( 'useloader' ) === true && options.useloader === 'did-you-know' ) {
				return this._loader._containers.didYouKnow;
			}

			return this._loader._containers.default;
		},

		randomizeDidYouKnowLoaderMessage: function( ) {
			var strings = this.getStrings(),
				didYouKnowMessages = strings.hasOwnProperty( 'loaderMessages' ) ? strings.loaderMessages : null,
				stringIndex;

			if ( didYouKnowMessages !== null ) {
				stringIndex = Math.floor( Math.random( ) * didYouKnowMessages.length );
				$( '#pyDidYouKnowPageLoader p' ).text( didYouKnowMessages[ stringIndex ] );
			}
		},

		/**
		 * Displays a loader
		 *
		 * @param {DOMElement}	aContainer 	Container to show loader on
		 * @param {JSONObject}	aOptions 	Options for loader
		 */

		showLoader: function( aContainer, aOptions ) {
			var container = $( aContainer ),
				options = aOptions || { },
				fullscreen, top, promise,
				loaderContainer = this.getLoaderContainerAvailable( aOptions ),
				self = this;

			if ( options.hasOwnProperty( 'useloader' ) && options.useloader === 'did-you-know' ) {
				this.randomizeDidYouKnowLoaderMessage( );
			}

			// Show loader over entire module
			if ( container.is( '#pyModule' ) === true ) {
				if ( options.loader !== 'none' ) {
					// Determine if we're showing over the full page or just pyModule
					fullscreen = false;

					// If we're double calling showLoader before hideLoader is called, maintain fullscreen if it's already set
					if ( loaderContainer.hasClass( 'active' ) === true && loaderContainer.hasClass( 'fullscreen' ) === true ) {
						fullscreen = true;
					}
					else if ( this.$container.hasClass( 'hide-nav' ) === true ) {
						fullscreen = true;
					}
					else if ( options.hasOwnProperty( 'loader' ) === true && options.loader === 'fullscreen' ) {
						fullscreen = true;
					}

					loaderContainer.toggleClass( 'fullscreen', fullscreen );

					// Determine how far from the top the container should be
					loaderContainer.prop( "style" ).removeProperty( "top" );
					if ( fullscreen === false ) {
						top = Math.max( 0, parseInt( loaderContainer.css( 'top' ), 10 ) - $( window ).scrollTop( ) );
						loaderContainer.css( 'top', top );
					}

					if ( loaderContainer.hasClass( 'active' ) === false ) {
						// Build a promise object
						promise = $.Deferred( );

						this._loader.promises.push( promise );

						// Disable scrolling
						$( 'body' ).addClass( 'no-scroll' );

						// Animate loader overlay in
						loaderContainer.addClass( 'active' ).css( 'opacity', 0 ).show( ).velocity( 'finish' ).velocity( { opacity: 1 }, {
							duration: this._loader.animation_duration,
							complete: function( ) {
								loaderContainer.addClass( 'fully-loaded' );
								promise.resolve( );
							}
						} );

						// Set up the animated gif loader
						loaderContainer.find( '> .page-loader' ).css( 'opacity', 0 );
						self.loaderContainer = loaderContainer;
						setTimeout( function( ) {
							var promise;

							// If we still have a promise (resolved or not), reset it
							if ( self._loader.promises.length !== 0 ) {
								// Push new promise into list
								promise = $.Deferred( );

								self._loader.promises.push( promise );

								self.loaderContainer.find( '> .page-loader' ).velocity( 'stop' ).velocity( { opacity: 1 }, {
									duration: self._loader.animation_duration,
									complete: function( ) {
										promise.resolve( );
									}
								} );
							}

						}, this._loader.display_loader_duration );
					}
				}
			}
			else {
				this.showProgress( aContainer, aOptions );
			}
		},

		/**
		 * Hide the loader on the container
		 */

		hideLoader: function( aContainer ) {
			var container = $( aContainer ),
				isDidYouKnow = this._loader._containers.didYouKnow.hasClass( 'active' ),
				loaderContainer = isDidYouKnow ? this._loader._containers.didYouKnow : this._loader._containers.default,
				velocityAction = isDidYouKnow ? 'finish' : 'stop',
				waitingPeriodBeforeRemovingLoader = isDidYouKnow ? 1000 : 0,
				self = this;

			if ( container.is( '#pyModule' ) === true ) {
				if ( loaderContainer.hasClass( 'fully-loaded' ) === true ) {
					this._loader.promises = [ ];

					self.loaderContainer = loaderContainer;

					setTimeout( function( ) {
						// Animate loader out
						loaderContainer.velocity( velocityAction ).velocity( { opacity: 0 }, {
							duration: self._loader.animation_duration,
							complete: function( ) {
								self.loaderContainer.removeClass( 'active' ).removeClass( 'fully-loaded' ).hide( );

								$( 'body' ).removeClass( 'no-scroll' );

								// Now that the body is visible, elements inside it are capable of focus
								if ( self._module !== null ) {
									self._module.autofocus.apply( self._module, [ self.$container ] );
								}
							}
						} );
					}, waitingPeriodBeforeRemovingLoader );
				}
			}
			else {
				this.hideProgress( aContainer );
			}
		},

		/**
		 * Method: showProgress
		 * @param {DOMelement} aContainer
		 * @param {JSONObject} aOptions
		 */

		showProgress: function( aContainer, aOptions ) {
			var container = $( aContainer ),
				options = aOptions || { },
				overlay;

			if ( options.loader !== 'none' ) {
				// Update overlay if it exists in container
				if ( container.find( '> div.overlay' ).length !== 0 ) {
					overlay = container.find( '> div.overlay' );
				}
				else {
					overlay = this.$overlay.clone( );
				}

				options = $.extend( true, {
					body: '',
					opacity: 0.2
				}, options );

				overlay.find( '> .background' ).css( { opacity: options.opacity } );

				if ( options.body instanceof jQuery === true ) {
					overlay.find( '> span.content > span.body' ).append( options.body.detach( ) );
				}
				else if ( options.body.length > 0 ) {
					overlay.find( '> span.content > span.body' ).html( '<h3 class="no-margin">' + options.body + '</h3>' );
				}

				container.append( overlay );
			}
		},

		/**
		 * Method: hideProgress
		 * @param {DOMelement} aContainer
		 */

		hideProgress: function( aContainer ) {
			var container = $( aContainer );

			container.find( '> div.overlay' ).remove( );
		},

		/**
		 * Clear current browser selection
		 */

		clearSelection: function( ) {
			if ( window.getSelection ) {
				if ( window.getSelection( ).empty ) { // Chrome
					window.getSelection( ).empty( );
				}
				else if ( window.getSelection( ).removeAllRanges ) { // Firefox
					window.getSelection( ).removeAllRanges( );
				}
			}
			else if ( document.selection && document.selection.empty ) { // IE?
				document.selection.empty( );
			}
		},

		/**
		 * Method: getPostData
		 * @param {DOMelement} aElement
		 */

		getPostData: function( aElement ) {
			var el = $( aElement )[ 0 ],
				data = { },
				a, i, len;

			for ( i = 0, len = el.attributes.length; i < len; i++ ) {
				a = el.attributes[ i ];

				if ( /^data-/.test( a.name ) === true ) {
					data[ a.name.replace( /^data-/, '' ) ] = el.getAttribute( a.name );
				}
			}

			return data;
		},

		/**
		 * Method: processPostData
		 * @param {Object} aData
		 */

		processPostData: function( aData ) {
			var data = aData || { },
				fixed = { },
				i, key;

			for ( i in data ) {
				if ( data.hasOwnProperty( i ) === true ) {
					key = i;

					if ( this._post.indexOf( key ) !== -1 && key[ 0 ] !== '_' ) {
						key = '_' + key;
					}

					fixed[ key ] = data[ i ];
				}
			}

			return fixed;
		},

		/**
		 * Method: bindLinks
		 * @param {DOMelement} aContainer
		 */

		bindLinks: function( aContainer ) {
			var container = $( aContainer ),
				self = this;

			container.find( 'a.cinder' ).off( 'click.cinder' ).on( 'click.cinder', function( aEvent, aSkipCallback ) {
				var skip = aSkipCallback || false,
					link = this,
					redir = false,
					href, p;

				if ( $( link ).hasClass( 'disabled' ) === true ) {
					aEvent.preventDefault( );
					aEvent.stopPropagation( );
				}
				else if ( ( aEvent.hasOwnProperty( 'originalEvent' ) === false ) || ( aEvent.metaKey === false && aEvent.ctrlKey === false ) ) {
					aEvent.preventDefault( );

					href = link.getAttribute( 'href' );

					if ( href.indexOf( window.location.href.replace( /^https?:/, '' ) ) === -1 ) {
						// Set data-back on a link to 0 to override redir behaviour, & prevent save changes modal from appearing.
						if ( parseInt( link.getAttribute( 'data-back' ), 10 ) !== 0 ) {
							redir = true;
						}
					}

					if ( redir === true ) {
						p = $.Deferred( );

						p.done( function( ) {
							self.handleLinkClick( link, false, skip );
						} );

						if ( self._module !== null ) {
							self._module.beforeUnload( p );
						}
					}
					else {
						self.handleLinkClick( link, false, skip );
					}
				}
			} );

			return this;
		},

		/**
		 * Method: handleLinkCLick
		 * @param {DOMelement} aLink
		 * @param {Bool} aRedirect
		 * @param {Bool} aSkipCallback
		 */

		handleLinkClick: function( aLink, aRedirect, aSkipCallback ) {
			var link = aLink || document.createElement( 'a' ),
				redirect = aRedirect || false,
				skip = aSkipCallback || false,
				data = this.getPostData( link ),
				url, container, name, a,
				submit = true,
				self = this;

			a = $( link );

			url = link.href.replace( '//', '' );
			url = url.substr( url.indexOf( '/' ) );

			if ( url[ 0 ] !== '/' ) {
				url = '/' + url;
			}

			if ( data.hasOwnProperty( 'container' ) === true ) {
				container = $( data.container );

				name = data.container;
			}
			else if ( data.hasOwnProperty( 'modal' ) === true ) {
				container = this._modal.getAttribute( 'id' );

				name = url;
			}
			else {
				container = $( this.getData( 'system.options.default_container' ) );

				name = url;
			}

			if ( data.hasOwnProperty( 'condition' ) === true ) {
				if ( this._module !== null && $.isFunction( this._module[ data.condition ] ) === true ) {
					if ( data.hasOwnProperty( 'target' ) === true && data.target !== 'container' ) {
						container = container.find( data.target );
					}

					submit = this._module[ data.condition ]( {
						source: $( link ),
						container: container,
						data: data
					} );
				}
				else {
					this.verbose( 'app: condition ' + data.condition + ' skipped (method not found)' );
				}
			}

			if ( data.hasOwnProperty( 'back' ) === true && parseInt( data.back, 10 ) > 0 && window.history.length > 1 ) {
				if ( data.hasOwnProperty( 'loader' ) === true ) {
					self._history.loader = data.loader;
				}

				window.history.go( Math.abs( data.back ) * -1 );
			}
			else if ( submit === true ) {
				if ( skip === false && data.hasOwnProperty( 'callback' ) === true ) {
					if ( this._module !== null && $.isFunction( this._module[ data.callback ] ) === true ) {
						if ( data.hasOwnProperty( 'target' ) === true && data.target !== 'container' ) {
							container = container.find( data.target );
						}

						this._module[ data.callback ]( {
							source: $( link ),
							container: container,
							data: data
						} );
					}
				}
				else if ( ( link.href.indexOf( '#' ) === -1 ) && ( link.href !== window.location.href || redirect === true ) ) {
					this.getConduit( name ).ajax( {
						url: url,
						data: this.processPostData( data ),
						beforeSend: function( ) {
							if ( a.is( '.btn' ) === true ) {
								a.loading( true );
								a.disable( );
							}

							self.showLoader( container, data );

							if ( data.hasOwnProperty( 'before' ) === true && self._module !== null && $.isFunction( self._module[ data.before ] ) === true ) {
								if ( data.hasOwnProperty( 'target' ) === true && data.target !== 'container' ) {
									container = container.find( data.target );
								}

								self._module[ data.before ]( {
									source: a,
									container: container,
									data: data
								} );
							}
						},
						success: function( response ) {
							response._source = a;

							if ( a.is( '.btn' ) === true ) {
								a.loading( false );
								a.enable( );
							}

							// self._loader.promises should be an array of promises or null
							$.when.apply( $, self._loader.promises ).done( function( ) {
								self.load( response );
							} );
						},
						error: function( response ) {
							if ( a.is( '.btn' ) === true ) {
								a.loading( false );
								a.enable( );
							}

							self.hideLoader( container );

							if ( data.hasOwnProperty( 'error' ) === true && self._module !== null && $.isFunction( self._module[ data.error ] ) === true ) {
								self._module[ data.error ]( {
									source: $( link ),
									container: container,
									data: response
								} );
							}
						}
					} );
				}
				else {
					document.body.scrollTop = document.documentElement.scrollTop = 0;
				}
			}
			else {
				this.verbose( 'app: condition skipped request' );
			}

			return this;
		},

		/**
		 * Method: bindForms
		 * @param {DOMelement} aContainer
		 */

		bindForms: function( aContainer ) {
			var container = $( aContainer ),
				els = container.find( 'form.cinder' ),
				data, per_page, i, len, check_count,
				self = this;

			els.find( 'input[type="password"]' ).attr( 'autocomplete', 'new-password' );
			els.find( 'input[type="text"]' ).attr( 'autocomplete', 'off' );

			els.off( 'submit.cinder' ).on( 'submit.cinder', function( aEvent ) {
				var form = $( aEvent.target ),
					submit = form.find( 'button[type="submit"], input[type="submit"]' ),
					callback, container, target;

				aEvent.preventDefault( );

				if ( aEvent.hasOwnProperty( 'originalEvent' ) === false ) {
					self.handleFormSubmit( this );
				}
				else if ( form[ 0 ].hasAttribute( 'data-callback' ) === true ) {
					callback = form[ 0 ].getAttribute( 'data-callback' );

					if ( self._module !== null && $.isFunction( self._module[ callback ] ) === true ) {
						if ( form[ 0 ].hasAttribute( 'data-container' ) === true ) {
							container = $( form[ 0 ].getAttribute( 'data-container' ) );
						}
						else {
							container = $( self.getData( 'system.options.default_container' ) );
						}

						if ( form[ 0 ].hasAttribute( 'data-target' ) === true ) {
							target = form[ 0 ].getAttribute( 'data-target' );

							if ( target !== 'container' ) {
								container = container.find( target );
							}
						}

						self._module[ callback ]( {
							source: submit,
							container: container,
							data: self.getPostData( form )
						} );
					}
				}
				else {
					self.handleFormSubmit( this );
				}
			} );

			per_page = this.getData( 'system.options.search_per_page' );

			data = this.getData( 'module.data' );

			if ( data.hasOwnProperty( 'view' ) === true && data.view.hasOwnProperty( 'data' ) === true ) {
				data = data.view.data;
			}

			for ( i = 0, len = els.length; i < len; i++ ) {
				// Look for custom page size attribute first; if not found, use the system.options.search_per_page default.
				if ( els[ i ].hasAttribute( 'data-per-page' ) === true ) {
					check_count = parseInt( els[ i ].getAttribute( 'data-per-page' ), 10 );
				}
				else {
					check_count = per_page;
				}

				if ( els[ i ].hasAttribute( 'data-infinite' ) === true && data.hasOwnProperty( els[ i ].getAttribute( 'data-infinite' ) ) === true && data[ els[ i ].getAttribute( 'data-infinite' ) ].length === check_count ) {
					this.generateInfiniteMarker( els[ i ] );
				}

				if ( els[ i ].hasAttribute( 'data-modified' ) === true ) {
					this.handleFormChanges( els[ i ] );
				}
			}

			return this;
		},

		/**
		 * Method: handleFormChanges
		 * @param {DOMelement} aForm
		 */

		handleFormChanges: function( aForm ) {
			var form = $( aForm ),
				self = this;

			form.on( 'focus', 'input, select, textarea, checkbox, radio', function( aEvent ) {
				self.setFormDataState( form, aEvent );
			} );

			form.on( 'change', function( ) {
				var state, current;

				if ( this.hasAttribute( 'data-state' ) === true ) {
					state = JSON.parse( this.getAttribute( 'data-state' ) );
					current = self.getFormState( this );

					if ( $.equal( state, current ) === true ) {
						self.verbose( 'app: form is clean' );

						this.setAttribute( 'data-modified', 0 );
					}
					else {
						self.verbose( 'app: form is dirty' );

						this.setAttribute( 'data-modified', 1 );
					}
				}
			} );
		},

		/**
		 * Method: handleFormSubmit
		 * @param {DOMelement} aForm
		 */

		handleFormSubmit: function( aForm ) {
			var form = $( aForm ),
				container, callback, target, config,
				valid = true,
				submit = true,
				self = this;

			if ( form.data( 'validator' ) !== undefined ) {
				valid = form.valid( );
			}

			if ( form[ 0 ].hasAttribute( 'data-container' ) === true ) {
				container = $( form[ 0 ].getAttribute( 'data-container' ) );
			}
			else {
				container = $( this.getData( 'module.data.container' ) );
			}

			if ( form[ 0 ].hasAttribute( 'data-condition' ) === true ) {
				callback = form[ 0 ].getAttribute( 'data-condition' );

				if ( this._module !== null && $.isFunction( self._module[ callback ] ) === true ) {
					if ( form[ 0 ].hasAttribute( 'data-target' ) === true ) {
						target = form[ 0 ].getAttribute( 'data-target' );

						if ( target !== 'container' ) {
							container = container.find( target );
						}
					}

					submit = self._module[ callback ]( {
						source: form,
						container: container,
						data: this.getPostData( form )
					} );
				}
				else {
					this.verbose( 'app: condition ' + callback + ' skipped (method not found)' );
				}
			}

			if ( valid === false ) {
				this.verbose( 'app: validation skipped request' );
			}
			else if ( submit === false ) {
				this.verbose( 'app: condition skipped request' );
			}
			else {
				config = this.getFormConfig( form );

				this.getConduit( config.name ).ajax( config.options );

				this.resetFormState( form );
			}
		},

		/**
		 * Method: getFormConfig
		 * @param {DOMelement} aForm
		 */

		getFormConfig: function( aForm ) {
			var form = $( aForm ),
				button, url, name, data, container, i, config,
				options = { },
				self = this;

			// Loading button
			button = form.find( 'button[type="submit"].btn, input[type="submit"].btn' );

			url = form[ 0 ].getAttribute( 'action' ).replace( '//', '' );
			url = url.substr( url.indexOf( '/' ) );

			options.url = url;

			data = this.getPostData( form );

			if ( data.hasOwnProperty( 'modified' ) === true ) {
				delete data.modified;
				delete data.state;
				delete data.message;
			}

			if ( form[ 0 ].hasAttribute( 'enctype' ) === true && form[ 0 ].getAttribute( 'enctype' ) === 'multipart/form-data' ) {
				options.data = new FormData( form[ 0 ] );
				options.processData = false;
				options.contentType = false;
				options.cache = false;

				for ( i in data ) {
					if ( form[ 0 ].hasAttribute( 'data-' + i ) === true ) {
						options.data.append( '_' + i, form[ 0 ].getAttribute( 'data-' + i ) );
					}
				}

				if ( data.hasOwnProperty( 'container' ) === false ) {
					options.data.append( '_container', this.getData( 'module.data.container' ) );

					container = $( this.getData( 'module.data.container' ) );

					name = url;
				}
				else {
					container = $( data.container );

					name = data.container;
				}
			}
			else {
				options.data = form.serializeObject( );

				for ( i in data ) {
					if ( form[ 0 ].hasAttribute( 'data-' + i ) === true ) {
						options.data[ '_' + i ] = form[ 0 ].getAttribute( 'data-' + i );
					}
				}

				if ( data.hasOwnProperty( 'container' ) === false ) {
					options.data._container = this.getData( 'module.data.container' );

					name = url;
				}
				else {
					name = data.container;
				}

				container = $( options.data._container );
			}

			if ( container.parent( ).is( 'div.modal-body' ) === true ) {
				container = container.closest( 'div.modal-content' );
			}

			options.beforeSend = function( ) {
				var before, target;

				self.clearMessage( 'system.options.validation_container' );

				self.toggleButtonLoading( button, true );

				if ( container.length > 0 && container.is( 'form' ) === false && container.find( '> div.overlay' ).length === 0 ) {
					self.showProgress( container );
				}

				if ( form[ 0 ].hasAttribute( 'data-before' ) === true ) {
					before = form[ 0 ].getAttribute( 'data-before' );

					if ( self._module !== null && $.isFunction( self._module[ before ] ) === true ) {
						if ( form[ 0 ].hasAttribute( 'data-target' ) === true ) {
							target = form[ 0 ].getAttribute( 'data-target' );

							if ( target !== 'container' ) {
								container = container.find( target );
							}
						}

						self._module[ before ]( {
							source: form,
							container: container,
							data: options.data
						} );
					}
				}
			};

			options.success = function( response ) {
				self.toggleButtonLoading( button, false );

				if ( container.length > 0 && container.find( '> div.overlay' ).length > 0 ) {
					self.hideProgress( container );
				}

				response._source = form;

				self.load( response );
			};

			options.error = function( response ) {
				self.toggleButtonLoading( button, false );

				if ( container.length > 0 && container.find( '> div.overlay' ).length > 0 ) {
					self.hideProgress( container );
				}

				if ( form[ 0 ].hasAttribute( 'data-error' ) === true && self._module !== null && $.isFunction( self._module[ form[ 0 ].getAttribute( 'data-error' ) ] ) === true ) {
					self._module[ form[ 0 ].getAttribute( 'data-error' ) ]( {
						source: form,
						container: container,
						data: response
					} );
				}
			};

			config = {
				name: name,
				options: options
			};

			return config;
		},

		/**
		 * Method: setFormDataState
		 * @param {DOMelement} aForm
		 * @param {DOMevent} aEvent
		 */

		setFormDataState: function( aForm, aEvent ) {
			var form = $( aForm ),
				data;

			if ( aEvent.hasOwnProperty( 'originalEvent' ) === true && form[ 0 ] && form[ 0 ].hasAttribute( 'data-state' ) === false ) {
				data = this.getFormState( form );

				form[ 0 ].setAttribute( 'data-state', JSON.stringify( data ) );
			}
		},

		/**
		 * Method: getFormState
		 * @param {DOMelement} aForm
		 */

		getFormState: function( aForm ) {
			var data = $( aForm ).serializeObject( ),
				state = { },
				i;

			for ( i in data ) {
				if ( /-typeahead$/.test( i ) === false ) {
					state[ i ] = data[ i ];
				}
			}

			return state;
		},

		/**
		 * Method: resetFormState
		 * @param {DOMelement} aForm
		 */

		resetFormState: function( aForm ) {
			var form = $( aForm );

			if ( form[ 0 ].hasAttribute( 'data-state' ) === true ) {
				form[ 0 ].removeAttribute( 'data-state' );
			}

			if ( form[ 0 ].hasAttribute( 'data-modified' ) === true ) {
				form[ 0 ].setAttribute( 'data-modified', 0 );
			}
		},

		/**
		 * Method: getTemplate
		 * @param {String} aSelector
		 */

		getTemplate: function( aSelector ) {
			return this.$templates.find( '> div[data-module="true"] > ' + aSelector ).detach( );
		},

		/**
		 * Method: restoreTemplate
		 * @param {DOMelement} aContainer
		 */

		restoreTemplate: function( aContainer ) {
			this.$templates.find( '> div[data-module="true"]' ).append( aContainer );
		},

		/**
		 * Method: getModal
		 */

		getModal: function( ) {
			return this.$modal.children( );
		},

		/**
		 * Method: generateMarker
		 * @param {DOMelement} aForm
		 */

		generateInfiniteMarker: function( aForm ) {
			var form = $( aForm ),
				tpl = this.$templates.find( 'div.scroll-container' ).clone( ),
				a = tpl.find( 'a' ),
				id = 'pyScrollInview_' + performance.now( ),
				target, data, i, offset, att,
				self = this;

			tpl[ 0 ].setAttribute( 'id', id );

			form.data( 'scroll-container', id );

			if ( form[ 0 ].hasAttribute( 'data-target' ) === true ) {
				target = $( form[ 0 ].getAttribute( 'data-target' ) );
			}
			else {
				target = $( form[ 0 ].getAttribute( 'data-container' ) );
			}

			target.after( tpl );

			// Copy form data to marker
			data = this.getFormConfig( form ).options.data;

			for ( i in data ) {
				if ( data.hasOwnProperty( i ) === true ) {
					// Remove leading underscores
					att = i.replace( /^_/, '' );

					if ( i.indexOf( '[' ) !== -1 ) {
						// If an array is passed encode it's value
						att = att.replace( '[]', '' );

						a[ 0 ].setAttribute( 'data-' + att, encodeURIComponent( data[ i ] ) );
					}
					else {
						a[ 0 ].setAttribute( 'data-' + att, data[ i ] );
					}
				}
			}

			a.attr( 'href', form[ 0 ].getAttribute( 'action' ) );
			a.attr( 'data-method', 'append' );

			// Look for custom data-per-page attribute, and use the default system value otherwise
			if ( form[ 0 ].hasAttribute( 'data-per-page' ) === true ) {
				offset = parseInt( form[ 0 ].getAttribute( 'data-per-page' ), 10 );
			}
			else {
				offset = this.getData( 'system.options.search_per_page' );
			}

			a.attr( 'data-offset', offset );

			a.on( 'click inview', function( aEvent, aView ) {
				aEvent.preventDefault( );

				if ( aView === undefined || aView === true ) {
					self.handleLinkClick( this );
				}
			} );

			return a;
		},

		/**
		 * Method: deleteInfiniteMarker
		 * @param {DOMelement} aSource
		 */

		deleteInfiniteMarker: function( aSource ) {
			var source = $( aSource ),
				selector, container;

			if ( source.is( 'form' ) === true ) {
				selector = source.data( 'scroll-container' );

				if ( selector !== '' ) {
					container = document.getElementById( selector );
				}

				source.data( 'scroll-container', '' );
			}
			else {
				container = source.closest( 'div.scroll-container' );
			}

			$( container ).remove( );
		},

		/**
		 * Method: updateInfiniteMarker
		 * @param {DOMelement} aSource
		 * @param {Object} aData
		 */

		updateInfiniteMarker: function( aSource, aData ) {
			var source = $( aSource ),
				data = aData || { },
				offset, count, check_count;

			if ( data.hasOwnProperty( 'view' ) === true && data.view.hasOwnProperty( 'data' ) === true ) {
				data = data.view.data;
			}

			if ( source[ 0 ].hasAttribute( 'data-infinite' ) === true && data.hasOwnProperty( source[ 0 ].getAttribute( 'data-infinite' ) ) === true ) {
				count = data[ source.attr( 'data-infinite' ) ].length;

				// Look for custom data-per-page attribute, but use system default otherwise
				if ( source[ 0 ].hasAttribute( 'data-per-page' ) === true ) {
					check_count = parseInt( source[ 0 ].getAttribute( 'data-per-page' ), 10 );
				}
				else {
					check_count = this.getData( 'system.options.search_per_page' );
				}

				if ( count < check_count ) {
					this.deleteInfiniteMarker( source );
				}
				else if ( source.is( 'form' ) === true ) {
					this.deleteInfiniteMarker( source );

					this.generateInfiniteMarker( source );
				}
				else {
					offset = parseInt( source[ 0 ].getAttribute( 'data-offset' ), 10 ) + count;

					source.attr( 'data-offset', offset );
				}
			}
		},

		/**
		 * Method: events
		 * @param {Object} aData
		 */

		events: function( aData ) {
			var data = aData || { };

			if ( this._module !== null ) {
				this._module.handleEvents( data );
			}
		},

		/**
		 * Passes user login data to the current module if it exists
		 *
		 * @param {JSONObject} aData
		 */

		login: function( aData ) {
			var data = aData || { };

			if ( this._module !== null ) {
				this._module.handleUserLogin( data );
			}
		},

		/**
		 * Method: getStrings
		 */

		getStrings: function( ) {
			return this._strings.getAll( );
		},

		/**
		 * Method: setStrings
		 * @param {Object} aStrings
		 */

		setStrings: function( aStrings ) {
			var strings = aStrings || { },
				i;

			for ( i in strings ) {
				if ( strings.hasOwnProperty( i ) === true ) {
					this._strings.set( i, strings[ i ] );
				}
			}
		},

		/**
		 * Method: updateViewStrings
		 * @param {Object} aData
		 */

		updateViewStrings: function( aData ) {
			var data = aData || { },
				strings = this.getStrings( ),
				container = $( 'body' ),
				els = container.find( '[data-string]' ),
				t, s, bundle, key,
				i, len, j;

			this.verbose( 'app: updating ' + els.length + ' strings', data );

			for ( i = 0, len = els.length; i < len; i++ ) {
				t = els[ i ].getAttribute( 'data-string' ).split( '.' );

				bundle = t[ 0 ];
				key = t[ 1 ];

				if ( bundle in strings && key in strings[ bundle ] ) {
					s = strings[ bundle ][ key ];

					for ( j in data ) {
						if ( data.hasOwnProperty( j ) === true ) {
							s = s.replace( '{' + j + '}', data[ j ] );
						}
					}

					$( els[ i ] ).string( s );
				}
			}
		},

		/**
		 * Advances the current tutorial
		 */

		tutorialNext: function( ) {
			this._tutorial.next( );
		},

		/**
		 * Goes back a substep in the current tutorial
		 */

		tutorialPrevious: function( ) {
			this._tutorial.previous( );
		},

		/**
		 * Skips the current tutorial
		 */

		tutorialSkip: function( ) {
			this._tutorial.skip( );
		},

		/**
		 * Method: createLink
		 * Helper to return an a element containing all of the attributes of the original given aElement.
		 * Also accepts a single string parameter which is treated as the value for the 'href' key.
		 * Also accepts a plain object array of keys and values.
		 *
		 * @param  {DOMElement|string|Object} aElement
		 * @param  {Boolean} aIgnoreIncludes
		 *
		 * @return {DOMElement}
		 */

		createLink: function( aElement, aIgnoreIncludes ) {
			var a = document.createElement( 'a' ),
				ignore_includes = ( aIgnoreIncludes || false ),
				included = this._post.slice( ), // clones the array
				i, len, attrs, attr, name;

			// Add to the list of included (copied-over) attributes
			included.push( 'href', 'ids', 'loader', 'callback' );

			if ( aElement !== undefined ) {
				if ( typeof aElement === 'string' ) {
					// Treat the parameter as href
					a.setAttribute( 'href', aElement );
				}
				else if ( $.isPlainObject( aElement ) === true ) {
					// Apply the keys and values as given
					for ( i in aElement ) {
						if ( aElement.hasOwnProperty( i ) === true ) {
							name = i;

							if ( name.substr( 0, 5 ) === 'data-' ) {
								name = name.substr( 5 );
							}

							if ( ignore_includes === true || included.indexOf( name ) !== -1 ) {
								a.setAttribute( i, aElement[ i ] );
							}
						}
					}
				}
				else {
					attrs = $( aElement )[ 0 ].attributes;

					for ( i = 0, len = attrs.length; i < len; i++ ) {
						attr = attrs[ i ];
						// Disregard blank value attributes
						if ( attr.value + '' !== '' ) {
							// Disregard reserved attributes that don't tend to be useful when copying them over
							name = attr.name;

							if ( name.substr( 0, 5 ) === 'data-' ) {
								name = name.substr( 5 );
							}

							if ( ignore_includes === true || included.indexOf( name ) !== -1 ) {
								a.setAttribute( attr.name, attr.value );
							}
						}
					}
				}
			}

			return a;
		},

		/**
		 * Method: bindEmitterEventListeners
		 */

		bindEmitterEventListeners: function( ) {
			var emitter = this.getEmitter( ),
				self = this;

			if ( emitter !== null ) {
				emitter.on( 'broadcast', function( aData ) {
					var data = aData || { },
						user_data = self.getData( 'system.user' ),
						tpl, params;

					self.verbose( 'Emitter received broadcast event ', data );

					if ( self._module !== null ) {
						// Check if this broadcast is specifically only for one particular user
						if ( ( data.type === 'user' && parseInt( data.user, 10 ) === parseInt( user_data.id, 10 ) ) || data.type !== 'user' ) {
							if ( data.text !== null && data.text !== '' ) {
								tpl = self.$templates.find( '> div.emitter > div.broadcast' ).clone( );

								tpl.find( '.broadcast-text' ).html( data.text );

								if ( data.hasOwnProperty( 'data' ) === true && data.data.hasOwnProperty( 'link' ) === true ) {
									tpl.find( '.broadcast-link' )
										.removeClass( 'hidden' )
										.attr( 'href', data.data.link.href )
										.text( data.data.link.title )
									;
								}

								params = {
									body: tpl.get( 0 ).outerHTML,
									placement: {
										align: 'right'
									},
									offset: {
										x: 5,
										y: 5
									},
									animate: {
										enter: 'animated fadeInRight',
										exit: 'animated fadeOutRight'
									}
								};

								if ( data.hasOwnProperty( 'delay' ) === true ) {
									params.delay = data.delay;
								}

								self._module.notification( params );
							}

							if ( data.hasOwnProperty( 'callback' ) === true && $.isFunction( self._module[ data.callback ] ) === true ) {
								self._module[ data.callback ]( data.data );
							}
						}
					}
				} );
			}
		},

		/**
		 * Method: addSplitTest
		 * Add AB test (designed to be invoked via VWO code snippet)
		 *
		 * @param {Object} aTest
		 */

		addSplitTest: function( aTest ) {
			var found = false,
				i, len, test;

			test = $.extend( true, {
				name: null,
				variant: 'a',
				optional: false,
				ui: {
					microvariants: [ ]
				}
			}, aTest );

			if ( test.name !== null ) {
				for ( i = 0, len = this._ab.length; i < len; i++ ) {
					if ( this._ab[ i ].name === test.name ) {
						found = true;

						break;
					}
				}

				// Add it if not found
				if ( found === false ) {
					this.verbose( 'added split test ' + test.name + ' using variant ' + test.variant );

					this._ab.push( test );
				}
				else {
					// Found, update UI in case it's changed
					this._ab[ i ].ui = test.ui;
				}
			}
		},

		/**
		 * Method: injectSplitTestUI
		 */

		injectSplitTestUI: function( ) {
			var self = this,
				i, len, test;

			for ( i = 0, len = this._ab.length; i < len; i++ ) {
				// Collapse ui object state into the main test object
				test = $.extend( true, { }, this._ab[ i ].ui, this._ab[ i ] );

				// Ensure the route matches (if present), and the target exists
				if ( ( test.route === null || test.route === undefined || window.location.pathname.match( test.route ) ) !== null && $( test.target ).length > 0 ) {
					// IIFE to keep test/currentTest in scope
					( function( currentTest ) {
						self.renderView( self.request( {
							container: currentTest.target,
							action: { method: 'append' },
							view: {
								path: 'system/views/components/abtest',
								data: {
									test: currentTest,
									_base_url: self.getData( 'module.options.base_url' ),
									strings: self.getStrings( )[ 'ab' ]
								}
							}
						} ), function( aContainer ) {
							var panel = $( aContainer ).find( 'div.beta-options-wrapper' );

							panel.find( '[data-toggle="tooltip"]' ).tooltip( {
								trigger: 'hover',
								container: 'body'
							} );

							// 1 signifies 'has not chosen yet'
							if ( currentTest.hasOwnProperty( 'value' ) === true && parseInt( currentTest.value, 10 ) === 1 ) {
								panel.addClass( 'attention' );
							}
							else {
								panel.addClass( 'chosen' );
							}
						} );
					} )( test );
				}
			}
		},

		/**
		 * Method: clearAB
		 */

		clearAB: function( ) {
			this._ab = [ ];
		},

		/**
		 * Method: getABTest
		 *
		 * @param {String} aName	AB test name (omitting the 'abtest.')
		 *
		 * @return false|object (no available AB test by that name, or the test object itself)
		 */

		getABTest: function( aName ) {
			var i, len;

			for ( i = 0, len = this._ab.length; i < len; i++ ) {
				if ( this._ab[ i ].name === aName ) {
					return this._ab[ i ];
				}
			}

			return false;
		},

		/**
		 * @param {Object} aDataDogInstance - (DD_LOGS) DataDog object instance from its snippet.
		 *
		 * @return {void}
		 */

		setDataDog: function( aDataDogInstance ) {
			this._datadog = aDataDogInstance;
		}
	} );

	return App;
} );

